import { DEPLOY_ASSET_VERSION } from '../utils/assetCache';
const ICONS = {
  home: '/header-nav/home.png',
  slots: '/header-nav/slots.png',
  sport: '/header-nav/sport.png',
  'sport-live': '/header-nav/sport-live.png',
  casino: '/header-nav/casino.png',
  live: '/header-nav/live.png',
  aviator: '/header-nav/aviator.png',
  new: '/header-nav/new.png',
  fast: '/header-nav/fast.png',
  poker: '/header-nav/poker.png',
  tv: '/header-nav/tv.png',
  vip: '/header-nav/vip.png',
  promos: '/header-nav/promos.png',
  help: '/header-nav/help.png',
  virtual: '/header-nav/virtual.png',
};

function resolveNavIconKey(item) {
  if (item.id && ICONS[item.id]) return item.id;
  if (item.sportFilter === 'live') return 'sport-live';
  if (item.lobbyKey && ICONS[item.lobbyKey]) return item.lobbyKey;
  const pageId = item.pageId || item.id;
  if (pageId === 'home') return 'home';
  if (pageId === 'sport') return 'sport';
  if (pageId === 'vip') return 'vip';
  if (pageId === 'promos') return 'promos';
  if (pageId === 'help') return 'help';
  if (pageId === 'casino' && item.casinoTabId === '447') return 'new';
  if (pageId === 'casino') return 'slots';
  return null;
}

export default function HeaderNavIcon({ item }) {
  const key = resolveNavIconKey(item);
  if (!key) return null;

  const base = ICONS[key];
  if (!base) return null;
  const src = `${base}?v=${encodeURIComponent(DEPLOY_ASSET_VERSION)}`;

  const isLive = key === 'sport-live';

  return (
    <span className={`header-nav-item__icon${isLive ? ' header-nav-item__icon--live' : ''}`}>
      <img src={src} alt="" width={20} height={20} draggable={false} />
    </span>
  );
}
